import { render, staticRenderFns } from "./OrdemDeServicoView.vue?vue&type=template&id=7cf82588"
import script from "./OrdemDeServicoView.vue?vue&type=script&setup=true&lang=js"
export * from "./OrdemDeServicoView.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports